export default {"src":"/_next/static/image/public/images/flags/flag_267.03b225f2e63d9a4213757d7e7e9161bf.svg","height":16,"width":25};